// V3 Theme Configuration
export const v3Theme = {
  // Typography
  typography: {
    fontFamily: "'JetBrains Mono', 'Menlo, Consolas, Liberation Mono', monospace",
  },
  
  // Main brand colors
  main: '#2c3e50',           // Dark blue-gray - primary brand color
  secondary: '#ecf0f1',      // Light gray - secondary backgrounds
  
  // Status colors
  success: '#2ecc71',        // Green - success states
  info: '#3498db',           // Blue - info states
  warning: '#f1c40f',        // Yellow - warning states (not used yet but standard)
  error: '#e74c3c',          // Red - error states (not used yet but standard)
  
  // Background colors
  background: {
    default: '#f9fafb',      // Main app background
    paper: '#FFFFFF',        // Card/paper backgrounds
    elevated: 'rgba(255, 255, 255, 0.95)', // Elevated surfaces with transparency
    dark: '#111827',         // Dark backgrounds (nav active states)
    hover: '#F3F4F6',        // Hover states
  },
  
  // Text colors
  text: {
    primary: '#2c3e50',      // Primary text
    secondary: '#6B7280',    // Secondary/muted text
    disabled: '#9CA3AF',     // Disabled text
    contrast: '#FFFFFF',     // Text on dark backgrounds
  },
  
  // Border colors
  border: {
    light: '#E5E7EB',        // Light borders
    medium: '#D1D5DB',       // Medium borders
    white: '#FFFFFF',        // White borders (avatar)
  },
  
  // Special UI elements
  ui: {
    progressRingInner: '#f5f6fa',  // Progress ring inner circle
    shadowColor: 'rgba(0, 0, 0, 0.1)', // Box shadows
    landWatchBg: '#F4F3FE',  // Light purple background used in LandWatch sections (header, rewards, loot, status)
    landWatchEnterBtn: '#76ED87',  // Green button for entering land watch mode
    landWatchEnterText: '#3D8A76',  // Dark green text for enter button
    landWatchExitBtn: '#F0A35F',  // Orange button for exiting land watch mode
    landWatchExitText: '#CD3922',  // Dark red text for exit button
    itemQtyBg: 'rgba(0, 0, 0, 0.6)',  // Dark translucent background for item quantity badges
    primaryBg: '#2c3e50',  // Main brand color for primary buttons
    primaryText: '#FFFFFF',  // White text for primary buttons
    itemIconRadius: '8px',  // Border radius for item icons throughout the app
  },
  
  // Loading states
  loading: {
    infoActive: '#2980b9',         // Loading info border active
  },
  
  // Button colors
  button: {
    primary: '#2c3e50',           // Dark blue for primary actions (deposit)
    primaryHover: '#1a252f',      // Darker blue on hover
    secondary: '#34495e',         // Slightly lighter blue for secondary actions (withdraw)
    secondaryHover: '#2c3e50',    // Darker on hover
    disabled: '#E5E7EB',          // Light gray for disabled buttons
  }
};

// CSS variables export for use in styles
export const v3CSSVariables = `
  --v3-main: ${v3Theme.main};
  --v3-secondary: ${v3Theme.secondary};
  --v3-success: ${v3Theme.success};
  --v3-info: ${v3Theme.info};
  --v3-warning: ${v3Theme.warning};
  --v3-error: ${v3Theme.error};
  
  --v3-bg-default: ${v3Theme.background.default};
  --v3-bg-paper: ${v3Theme.background.paper};
  --v3-bg-elevated: ${v3Theme.background.elevated};
  --v3-bg-dark: ${v3Theme.background.dark};
  --v3-bg-hover: ${v3Theme.background.hover};
  --v3-bg-primary: ${v3Theme.background.default};
  
  --v3-text-primary: ${v3Theme.text.primary};
  --v3-text-secondary: ${v3Theme.text.secondary};
  --v3-text-disabled: ${v3Theme.text.disabled};
  --v3-text-contrast: ${v3Theme.text.contrast};
  
  --v3-border-light: ${v3Theme.border.light};
  --v3-border-medium: ${v3Theme.border.medium};
  --v3-border-white: ${v3Theme.border.white};
  --v3-border: ${v3Theme.border.light};
  
  --v3-shadow: ${v3Theme.ui.shadowColor};
  --v3-ui-progressRingInner: ${v3Theme.ui.progressRingInner};
  --v3-ui-landWatchBg: ${v3Theme.ui.landWatchBg};
  --v3-ui-landWatchEnterBtn: ${v3Theme.ui.landWatchEnterBtn};
  --v3-ui-landWatchEnterText: ${v3Theme.ui.landWatchEnterText};
  --v3-ui-landWatchExitBtn: ${v3Theme.ui.landWatchExitBtn};
  --v3-ui-landWatchExitText: ${v3Theme.ui.landWatchExitText};
  --v3-ui-itemQtyBg: ${v3Theme.ui.itemQtyBg};
  --v3-ui-primaryBg: ${v3Theme.ui.primaryBg};
  --v3-ui-primaryText: ${v3Theme.ui.primaryText};
  --v3-loading-infoActive: ${v3Theme.loading.infoActive};
`;

export default v3Theme;